"use strict";
var Observable_1 = require('../../Observable');
var materialize_1 = require('../../operator/materialize');
Observable_1.Observable.prototype.materialize = materialize_1.materialize;
//# sourceMappingURL=materialize.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/materialize.js
 ** module id = 228
 ** module chunks = 2
 **/